
export const validatePhoneNo = phone => {
  // const re = /^[0-9]{1,10}$/;
  // validate with country code
  const re = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  return re.test(phone);
}

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const cloundUrlGenerate = (buket, key) => {
  const t = {
    bucket: buket,
    key: key,
  };
  let suffix = convertBase64(JSON.stringify(t));
  let fullUrl = process.env.REACT_APP_CLOUD_FRONT_URL + "/" + suffix;
  return fullUrl;
};

const convertBase64 = (str) => {
  return Buffer.from(str).toString("base64");
};

export const isValidUrl = (str) => {
  let url;
  try {
    url = new URL(str);
  } catch (err) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:" || url.protocol === "blob:";
}

export const getDateInFormat = (dateStr) => {
  if (dateStr !== "" && dateStr != null) {
    var date = new Date(dateStr);
    return date.toISOString().split('T')[0];
  }
}

export const getStatus = (status) => {
  let user_status;
  switch (status) {
    case 0:
      user_status = "INACTIVE";
      break;
    case 1:
      user_status = "ACTIVE";
      break;
    case 2:
      user_status = "BLOCKED";
      break;
    case 3:
      user_status = "DELETED";
      break;
    case 4:
      user_status = "LOCK";
      break;
  }
  return user_status;
};

export const getRoles = (role_ids) => {
  let user_roles = [];

  if (role_ids === 1) user_roles.push("Super Admin");
  if (role_ids === 2) user_roles.push("Admin");
  if (role_ids === 3) user_roles.push("Operations");
  if (role_ids === 4) user_roles.push("Customer Service");
  if (role_ids === 5) user_roles.push("Doctor");
  if (role_ids === 6) user_roles.push("Patient");
  if (role_ids === 7) user_roles.push("Factory");
  
  return user_roles.join();
};

export const getGender = (gender) => {
  let user_gender;
  switch (gender) {
    case 0:
      user_gender = "Male";
      break;
    case 1:
      user_gender = "Female";
      break;
    case 2:
      user_gender = "Prefer not to say";
      break;
  }
  return user_gender;
};
export const validatePassword = (password, confirmPassword, isResetPwd = false) => {
  let passwordErr = null;
  let confirmPasswordErr = null;

  if (!password) {
    passwordErr = "Required";
  } 
  else if (password.length < 8) {
    passwordErr = "Password length must be atleast 8 characters";
  } 
  else if (!password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s)/)) {
    passwordErr = "Invalid password";
  } 
  else if (isResetPwd) {
    if (!confirmPassword) {
      confirmPasswordErr = "Required";
    } 
    else if (password !== confirmPassword) {
      confirmPasswordErr = "Passwords do not match";
    }
  }
  
  return {
    passwordErr,
    confirmPasswordErr
  };
}

export const stringConvert = (string_value) => {
  const new_string_value = string_value
    // insert a space before all caps
    .replace(/([A-Z])/g, ' $1')
    // uppercase the first character
    .replace(/^./, function(str){ return str.toUpperCase(); });
  return new_string_value;
}
